export default {
  quoteTemplates: [],
  quoteTemplate: undefined,
};
